import React from 'react';

import Subheader from '../Subheader';

import { SUBNAVIGATION_CAROUSEL_ID } from '../../model/constants';

interface SubNavigationPropTypes {
  onMenuItemClick?: (args: { path: string; itemTitle: string }) => void;
  currentPageId?: string;
  items: {
    title: string;
    route_link: string;
    type: string;
    state: string;
  }[];
  initialScrollValue?: number;
}

const Navigation = (props: SubNavigationPropTypes) => {
  const menuItems = props.items.map(item => {
    return {
      title: item.title,
      type: item.type,
      state: item.state,
      route_link: item.route_link,
    };
  });

  const handleMenuClick = (menuItem: {
    type: string;
    index: number;
    title: string;
  }) => {
    const { index } = menuItem;
    const { route_link } = menuItems[index];

    props.onMenuItemClick &&
      props.onMenuItemClick({ path: route_link, itemTitle: menuItem.title });
  };

  let initialScroll =
    props.initialScrollValue !== undefined
      ? {
          position: props.initialScrollValue,
          name: SUBNAVIGATION_CAROUSEL_ID,
        }
      : undefined;

  return (
    <Subheader
      items={menuItems}
      onClick={handleMenuClick}
      navHorizontalPadding={10}
      initialScroll={initialScroll}
      isSubNavigation={true}
    />
  );
};

export default Navigation;
